import axios from "axios";
const url = `${process.env.REACT_APP_BASE_URL}`;

const token = () => {
  let result =  JSON.parse(localStorage.getItem("jwt"));
  if (result) {
    return result.authenticationToken;
  } else {
    return "";
  }
};

const api = axios.create({
  baseURL: url,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token()}`
  }
});

export default api;
